var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "printer-edit-form" }, [
      _c("div", { staticClass: "button-wrapper top" }, [
        _c(
          "div",
          {
            staticClass: "button",
            on: {
              click: function($event) {
                return _vm.savePrinter()
              }
            }
          },
          [_vm._v("Save")]
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("type")]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.printer.type,
                  expression: "printer.type"
                }
              ],
              staticClass: "dashboard-select",
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.printer,
                    "type",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                }
              }
            },
            _vm._l(_vm.types, function(type) {
              return _c("option", { domProps: { value: type } }, [
                _vm._v(_vm._s(type))
              ])
            }),
            0
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("manufacturer_id")]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.printer.manufacturer_id,
                  expression: "printer.manufacturer_id"
                }
              ],
              staticClass: "dashboard-select",
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.printer,
                    "manufacturer_id",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                }
              }
            },
            _vm._l(_vm.manufacturers, function(manufacturer) {
              return _c("option", { domProps: { value: manufacturer.id } }, [
                _vm._v(_vm._s(manufacturer.name))
              ])
            }),
            0
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("model")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.model,
                expression: "printer.model"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.model },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "model", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("image_url")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.image_url,
                expression: "printer.image_url"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.image_url },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "image_url", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("speed_standard")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.speed_standard,
                expression: "printer.speed_standard"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.speed_standard },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "speed_standard", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("auto_size_weight")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.auto_size_weight,
                expression: "printer.auto_size_weight"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.auto_size_weight },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "auto_size_weight", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("scale_capacity")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.scale_capacity,
                expression: "printer.scale_capacity"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.scale_capacity },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "scale_capacity", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("envelope_thickness_capacity")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.envelope_thickness_capacity,
                expression: "printer.envelope_thickness_capacity"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.envelope_thickness_capacity },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "envelope_thickness_capacity",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("programmable_jobs")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.programmable_jobs,
                expression: "printer.programmable_jobs"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.programmable_jobs },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "programmable_jobs", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("departmental_accounting")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.departmental_accounting,
                expression: "printer.departmental_accounting"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.departmental_accounting },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "departmental_accounting",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("ink_yield")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.ink_yield,
                expression: "printer.ink_yield"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.ink_yield },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "ink_yield", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("ink_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.ink_cost,
                expression: "printer.ink_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.ink_cost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "ink_cost", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("ink_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.ink_sell_price,
                expression: "printer.ink_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.ink_sell_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "ink_sell_price", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("ink_delivery_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.ink_delivery_cost,
                expression: "printer.ink_delivery_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.ink_delivery_cost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "ink_delivery_cost", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("cost_per_impression")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.cost_per_impression,
                expression: "printer.cost_per_impression"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.cost_per_impression },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "cost_per_impression",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("label_pack_size")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.label_pack_size,
                expression: "printer.label_pack_size"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.label_pack_size },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "label_pack_size", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("label_pack_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.label_pack_cost,
                expression: "printer.label_pack_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.label_pack_cost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "label_pack_cost", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("label_pack_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.label_pack_sell_price,
                expression: "printer.label_pack_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.label_pack_sell_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "label_pack_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("cost_per_label")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.cost_per_label,
                expression: "printer.cost_per_label"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.cost_per_label },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "cost_per_label", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("return_address_capacity")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.return_address_capacity,
                expression: "printer.return_address_capacity"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.return_address_capacity },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "return_address_capacity",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("return_address_included_with_machine")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.return_address_included_with_machine,
                expression: "printer.return_address_included_with_machine"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value: _vm.printer.return_address_included_with_machine
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "return_address_included_with_machine",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("return_address_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.return_address_cost,
                expression: "printer.return_address_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.return_address_cost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "return_address_cost",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("return_address_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.return_address_sell_price,
                expression: "printer.return_address_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.return_address_sell_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "return_address_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("business_mail_advanced")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.business_mail_advanced,
                expression: "printer.business_mail_advanced"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.business_mail_advanced },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "business_mail_advanced",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("business_mail_advanced_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.business_mail_advanced_cost,
                expression: "printer.business_mail_advanced_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.business_mail_advanced_cost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "business_mail_advanced_cost",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("business_mail_advanced_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.business_mail_advanced_sell_price,
                expression: "printer.business_mail_advanced_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.business_mail_advanced_sell_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "business_mail_advanced_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("interface_type")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.interface_type,
                expression: "printer.interface_type"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.interface_type },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "interface_type", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("mail_feeder")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.mail_feeder,
                expression: "printer.mail_feeder"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.mail_feeder },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "mail_feeder", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("label_dispenser")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.label_dispenser,
                expression: "printer.label_dispenser"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.label_dispenser },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "label_dispenser", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("web_based_reporting")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.web_based_reporting,
                expression: "printer.web_based_reporting"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.web_based_reporting },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "web_based_reporting",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("differential_weighting")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.differential_weighting,
                expression: "printer.differential_weighting"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.differential_weighting },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "differential_weighting",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("dimensions")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.dimensions,
                expression: "printer.dimensions"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.dimensions },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "dimensions", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("printing_capabilities")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.printing_capabilities,
                expression: "printer.printing_capabilities"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.printing_capabilities },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "printing_capabilities",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("shipping_application")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.shipping_application,
                expression: "printer.shipping_application"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.shipping_application },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "shipping_application",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("shipping_application_kit_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.shipping_application_kit_cost,
                expression: "printer.shipping_application_kit_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.shipping_application_kit_cost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "shipping_application_kit_cost",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("shipping_application_kit_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.shipping_application_kit_sell_price,
                expression: "printer.shipping_application_kit_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value: _vm.printer.shipping_application_kit_sell_price
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "shipping_application_kit_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("integrated_internal_mail_tracking_app")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.integrated_internal_mail_tracking_app,
                expression: "printer.integrated_internal_mail_tracking_app"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value: _vm.printer.integrated_internal_mail_tracking_app
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "integrated_internal_mail_tracking_app",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("integrated_internal_mail_tracking_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.integrated_internal_mail_tracking_cost,
                expression: "printer.integrated_internal_mail_tracking_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value: _vm.printer.integrated_internal_mail_tracking_cost
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "integrated_internal_mail_tracking_cost",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("integrated_internal_mail_tracking_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.integrated_internal_mail_tracking_sell_price,
                expression:
                  "printer.integrated_internal_mail_tracking_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value: _vm.printer.integrated_internal_mail_tracking_sell_price
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "integrated_internal_mail_tracking_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [
            _vm._v("integrated_internal_mail_tracking_service_cost")
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value:
                  _vm.printer.integrated_internal_mail_tracking_service_cost,
                expression:
                  "printer.integrated_internal_mail_tracking_service_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value: _vm.printer.integrated_internal_mail_tracking_service_cost
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "integrated_internal_mail_tracking_service_cost",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [
            _vm._v("integrated_internal_mail_tracking_service_sell_price")
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value:
                  _vm.printer
                    .integrated_internal_mail_tracking_service_sell_price,
                expression:
                  "printer.integrated_internal_mail_tracking_service_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value:
                _vm.printer.integrated_internal_mail_tracking_service_sell_price
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "integrated_internal_mail_tracking_service_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("connectivity")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.connectivity,
                expression: "printer.connectivity"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.connectivity },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "connectivity", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("connectivity_wifi_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.connectivity_wifi_cost,
                expression: "printer.connectivity_wifi_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.connectivity_wifi_cost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "connectivity_wifi_cost",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("connectivity_wifi_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.connectivity_wifi_sell_price,
                expression: "printer.connectivity_wifi_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.connectivity_wifi_sell_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "connectivity_wifi_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("connectivity_wifi_service_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.connectivity_wifi_service_cost,
                expression: "printer.connectivity_wifi_service_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.connectivity_wifi_service_cost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "connectivity_wifi_service_cost",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("connectivity_wifi_service_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.connectivity_wifi_service_sell_price,
                expression: "printer.connectivity_wifi_service_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value: _vm.printer.connectivity_wifi_service_sell_price
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "connectivity_wifi_service_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("connectivity_3g_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.connectivity_3g_cost,
                expression: "printer.connectivity_3g_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.connectivity_3g_cost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "connectivity_3g_cost",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("connectivity_3g_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.connectivity_3g_sell_price,
                expression: "printer.connectivity_3g_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.connectivity_3g_sell_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "connectivity_3g_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("connectivity_3g_service_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.connectivity_3g_service_cost,
                expression: "printer.connectivity_3g_service_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.connectivity_3g_service_cost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "connectivity_3g_service_cost",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("connectivity_3g_service_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.connectivity_3g_service_sell_price,
                expression: "printer.connectivity_3g_service_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.connectivity_3g_service_sell_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "connectivity_3g_service_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("mail_mark_compliant")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.mail_mark_compliant,
                expression: "printer.mail_mark_compliant"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.mail_mark_compliant },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "mail_mark_compliant",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("mail_mark_kit_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.mail_mark_kit_cost,
                expression: "printer.mail_mark_kit_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.mail_mark_kit_cost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "mail_mark_kit_cost", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("mail_mark_kit_delivery_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.mail_mark_kit_delivery_cost,
                expression: "printer.mail_mark_kit_delivery_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.mail_mark_kit_delivery_cost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "mail_mark_kit_delivery_cost",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("mail_mark_kit_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.mail_mark_kit_sell_price,
                expression: "printer.mail_mark_kit_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.mail_mark_kit_sell_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "mail_mark_kit_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("mail_mark_service_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.mail_mark_service_cost,
                expression: "printer.mail_mark_service_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.mail_mark_service_cost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "mail_mark_service_cost",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("mail_mark_service_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.mail_mark_service_sell_price,
                expression: "printer.mail_mark_service_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.mail_mark_service_sell_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "mail_mark_service_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("mail_mark_upgraded_service_cover")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.mail_mark_upgraded_service_cover,
                expression: "printer.mail_mark_upgraded_service_cover"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.mail_mark_upgraded_service_cover },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "mail_mark_upgraded_service_cover",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("mail_mark_upgraded_service_cover_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.mail_mark_upgraded_service_cover_sell_price,
                expression:
                  "printer.mail_mark_upgraded_service_cover_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value: _vm.printer.mail_mark_upgraded_service_cover_sell_price
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "mail_mark_upgraded_service_cover_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("scale_option_1")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.scale_option_1,
                expression: "printer.scale_option_1"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.scale_option_1 },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "scale_option_1", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("scale_option_1_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.scale_option_1_cost,
                expression: "printer.scale_option_1_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.scale_option_1_cost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "scale_option_1_cost",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("scale_option_1_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.scale_option_1_sell_price,
                expression: "printer.scale_option_1_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.scale_option_1_sell_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "scale_option_1_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("scale_option_1_service")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.scale_option_1_service,
                expression: "printer.scale_option_1_service"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.scale_option_1_service },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "scale_option_1_service",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("scale_option_1_service_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.scale_option_1_service_sell_price,
                expression: "printer.scale_option_1_service_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.scale_option_1_service_sell_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "scale_option_1_service_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("scale_option_2")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.scale_option_2,
                expression: "printer.scale_option_2"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.scale_option_2 },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "scale_option_2", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("scale_option_2_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.scale_option_2_cost,
                expression: "printer.scale_option_2_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.scale_option_2_cost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "scale_option_2_cost",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("scale_option_2_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.scale_option_2_sell_price,
                expression: "printer.scale_option_2_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.scale_option_2_sell_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "scale_option_2_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("scale_option_2_service")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.scale_option_2_service,
                expression: "printer.scale_option_2_service"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.scale_option_2_service },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "scale_option_2_service",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("scale_option_2_service_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.scale_option_2_service_sell_price,
                expression: "printer.scale_option_2_service_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.scale_option_2_service_sell_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "scale_option_2_service_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("scale_option_3")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.scale_option_3,
                expression: "printer.scale_option_3"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.scale_option_3 },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "scale_option_3", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("scale_option_3_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.scale_option_3_cost,
                expression: "printer.scale_option_3_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.scale_option_3_cost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "scale_option_3_cost",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("scale_option_3_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.scale_option_3_sell_price,
                expression: "printer.scale_option_3_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.scale_option_3_sell_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "scale_option_3_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("scale_option_3_service")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.scale_option_3_service,
                expression: "printer.scale_option_3_service"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.scale_option_3_service },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "scale_option_3_service",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("scale_option_3_service_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.scale_option_3_service_sell_price,
                expression: "printer.scale_option_3_service_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.scale_option_3_service_sell_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "scale_option_3_service_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("scale_option_4")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.scale_option_4,
                expression: "printer.scale_option_4"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.scale_option_4 },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "scale_option_4", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("scale_option_4_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.scale_option_4_cost,
                expression: "printer.scale_option_4_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.scale_option_4_cost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "scale_option_4_cost",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("scale_option_4_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.scale_option_4_sell_price,
                expression: "printer.scale_option_4_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.scale_option_4_sell_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "scale_option_4_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("scale_option_4_service")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.scale_option_4_service,
                expression: "printer.scale_option_4_service"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.scale_option_4_service },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "scale_option_4_service",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("scale_option_4_service_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.scale_option_4_service_sell_price,
                expression: "printer.scale_option_4_service_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.scale_option_4_service_sell_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "scale_option_4_service_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("differential_weighing_available")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.differential_weighing_available,
                expression: "printer.differential_weighing_available"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.differential_weighing_available },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "differential_weighing_available",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("differential_weighing_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.differential_weighing_cost,
                expression: "printer.differential_weighing_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.differential_weighing_cost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "differential_weighing_cost",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("differential_weighing_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.differential_weighing_sell_price,
                expression: "printer.differential_weighing_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.differential_weighing_sell_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "differential_weighing_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("accounting_option_1")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.accounting_option_1,
                expression: "printer.accounting_option_1"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.accounting_option_1 },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "accounting_option_1",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("accounting_option_1_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.accounting_option_1_cost,
                expression: "printer.accounting_option_1_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.accounting_option_1_cost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "accounting_option_1_cost",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("accounting_option_1_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.accounting_option_1_sell_price,
                expression: "printer.accounting_option_1_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.accounting_option_1_sell_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "accounting_option_1_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("accounting_option_2")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.accounting_option_2,
                expression: "printer.accounting_option_2"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.accounting_option_2 },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "accounting_option_2",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("accounting_option_2_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.accounting_option_2_cost,
                expression: "printer.accounting_option_2_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.accounting_option_2_cost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "accounting_option_2_cost",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("accounting_option_2_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.accounting_option_2_sell_price,
                expression: "printer.accounting_option_2_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.accounting_option_2_sell_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "accounting_option_2_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("accounting_option_3")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.accounting_option_3,
                expression: "printer.accounting_option_3"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.accounting_option_3 },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "accounting_option_3",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("accounting_option_3_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.accounting_option_3_cost,
                expression: "printer.accounting_option_3_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.accounting_option_3_cost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "accounting_option_3_cost",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("accounting_option_3_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.accounting_option_3_sell_price,
                expression: "printer.accounting_option_3_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.accounting_option_3_sell_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "accounting_option_3_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v(">accounting_option_4")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.accounting_option_4,
                expression: "printer.accounting_option_4"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.accounting_option_4 },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "accounting_option_4",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("accounting_option_4_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.accounting_option_4_cost,
                expression: "printer.accounting_option_4_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.accounting_option_4_cost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "accounting_option_4_cost",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("accounting_option_4_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.accounting_option_4_sell_price,
                expression: "printer.accounting_option_4_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.accounting_option_4_sell_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "accounting_option_4_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("accounting_option_5")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.accounting_option_5,
                expression: "printer.accounting_option_5"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.accounting_option_5 },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "accounting_option_5",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("accounting_option_5_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.accounting_option_5_cost,
                expression: "printer.accounting_option_5_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.accounting_option_5_cost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "accounting_option_5_cost",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("accounting_option_5_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.accounting_option_5_sell_price,
                expression: "printer.accounting_option_5_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.accounting_option_5_sell_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "accounting_option_5_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("engineer_installation_training")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.engineer_installation_training,
                expression: "printer.engineer_installation_training"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.engineer_installation_training },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "engineer_installation_training",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("engineer_installation_training_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.engineer_installation_training_cost,
                expression: "printer.engineer_installation_training_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value: _vm.printer.engineer_installation_training_cost
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "engineer_installation_training_cost",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("engineer_installation_training_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.engineer_installation_training_sell_price,
                expression: "printer.engineer_installation_training_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value: _vm.printer.engineer_installation_training_sell_price
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "engineer_installation_training_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("video_url")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.video_url,
                expression: "printer.video_url"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.video_url },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "video_url", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("comparable_new_pb_equivalent")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.comparable_new_pb_equivalent,
                expression: "printer.comparable_new_pb_equivalent"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.comparable_new_pb_equivalent },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "comparable_new_pb_equivalent",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("comparable_new_quadient_equivalent")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.comparable_new_quadient_equivalent,
                expression: "printer.comparable_new_quadient_equivalent"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.comparable_new_quadient_equivalent },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "comparable_new_quadient_equivalent",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("comparable_new_fp_equivalent")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.comparable_new_fp_equivalent,
                expression: "printer.comparable_new_fp_equivalent"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.comparable_new_fp_equivalent },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "comparable_new_fp_equivalent",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("comparable_new_frama_equivalent")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.comparable_new_frama_equivalent,
                expression: "printer.comparable_new_frama_equivalent"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.comparable_new_frama_equivalent },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "comparable_new_frama_equivalent",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("letters_per_day_recommendation")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.letters_per_day_recommendation,
                expression: "printer.letters_per_day_recommendation"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.letters_per_day_recommendation },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "letters_per_day_recommendation",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("parcel_per_day_recommendation")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.parcel_per_day_recommendation,
                expression: "printer.parcel_per_day_recommendation"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.parcel_per_day_recommendation },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "parcel_per_day_recommendation",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("total_volume_per_day_recommendation")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.total_volume_per_day_recommendation,
                expression: "printer.total_volume_per_day_recommendation"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value: _vm.printer.total_volume_per_day_recommendation
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "total_volume_per_day_recommendation",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("service_name")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.service_name,
                expression: "printer.service_name"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.service_name },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "service_name", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("first_step")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.first_step,
                expression: "printer.first_step"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.first_step },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "first_step", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("second_step")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.second_step,
                expression: "printer.second_step"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.second_step },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "second_step", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("third_step")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.third_step,
                expression: "printer.third_step"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.third_step },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "third_step", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("sla_standard")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.sla_standard,
                expression: "printer.sla_standard"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.sla_standard },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "sla_standard", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("enhanced_service_name")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.enhanced_service_name,
                expression: "printer.enhanced_service_name"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.enhanced_service_name },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "enhanced_service_name",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("enhanced_third_step")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.enhanced_third_step,
                expression: "printer.enhanced_third_step"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.enhanced_third_step },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "enhanced_third_step",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("sla_enhanced")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.sla_enhanced,
                expression: "printer.sla_enhanced"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.sla_enhanced },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "sla_enhanced", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("all_parts")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.all_parts,
                expression: "printer.all_parts"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.all_parts },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "all_parts", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("all_labour")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.all_labour,
                expression: "printer.all_labour"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.all_labour },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "all_labour", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("wear_and_tear")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.wear_and_tear,
                expression: "printer.wear_and_tear"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.wear_and_tear },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "wear_and_tear", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("tariff_rate_updates_included_per_annum")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.tariff_rate_updates_included_per_annum,
                expression: "printer.tariff_rate_updates_included_per_annum"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value: _vm.printer.tariff_rate_updates_included_per_annum
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "tariff_rate_updates_included_per_annum",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("postage_deposit_account")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.postage_deposit_account,
                expression: "printer.postage_deposit_account"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.postage_deposit_account },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "postage_deposit_account",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("postage_deposit_account_cost_per_resets")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.postage_deposit_account_cost_per_resets,
                expression: "printer.postage_deposit_account_cost_per_resets"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value: _vm.printer.postage_deposit_account_cost_per_resets
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "postage_deposit_account_cost_per_resets",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("postage_recrediting_cost_per_annum")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.postage_recrediting_cost_per_annum,
                expression: "printer.postage_recrediting_cost_per_annum"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.postage_recrediting_cost_per_annum },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "postage_recrediting_cost_per_annum",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("postage_credit_account_free_resets")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.postage_credit_account_free_resets,
                expression: "printer.postage_credit_account_free_resets"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.postage_credit_account_free_resets },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "postage_credit_account_free_resets",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("postage_credit_account_per_future_resets")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.postage_credit_account_per_future_resets,
                expression: "printer.postage_credit_account_per_future_resets"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value: _vm.printer.postage_credit_account_per_future_resets
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "postage_credit_account_per_future_resets",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("monthly_top_up_option_1")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.monthly_top_up_option_1,
                expression: "printer.monthly_top_up_option_1"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.monthly_top_up_option_1 },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "monthly_top_up_option_1",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("monthly_top_up_option_1_transaction_fee")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.monthly_top_up_option_1_transaction_fee,
                expression: "printer.monthly_top_up_option_1_transaction_fee"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value: _vm.printer.monthly_top_up_option_1_transaction_fee
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "monthly_top_up_option_1_transaction_fee",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [
            _vm._v("monthly_top_up_option_1_unlimited_transactions_monthly_fee")
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value:
                  _vm.printer
                    .monthly_top_up_option_1_unlimited_transactions_monthly_fee,
                expression:
                  "printer.monthly_top_up_option_1_unlimited_transactions_monthly_fee"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value:
                _vm.printer
                  .monthly_top_up_option_1_unlimited_transactions_monthly_fee
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "monthly_top_up_option_1_unlimited_transactions_monthly_fee",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("totalcare_transaction_fees_option_1")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.totalcare_transaction_fees_option_1,
                expression: "printer.totalcare_transaction_fees_option_1"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value: _vm.printer.totalcare_transaction_fees_option_1
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "totalcare_transaction_fees_option_1",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("monthly_top_up_option_2")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.monthly_top_up_option_2,
                expression: "printer.monthly_top_up_option_2"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.monthly_top_up_option_2 },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "monthly_top_up_option_2",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("monthly_top_up_option_2_transaction_fee")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.monthly_top_up_option_2_transaction_fee,
                expression: "printer.monthly_top_up_option_2_transaction_fee"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value: _vm.printer.monthly_top_up_option_2_transaction_fee
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "monthly_top_up_option_2_transaction_fee",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [
            _vm._v("monthly_top_up_option_2_unlimited_transactions_monthly_fee")
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value:
                  _vm.printer
                    .monthly_top_up_option_2_unlimited_transactions_monthly_fee,
                expression:
                  "printer.monthly_top_up_option_2_unlimited_transactions_monthly_fee"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value:
                _vm.printer
                  .monthly_top_up_option_2_unlimited_transactions_monthly_fee
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "monthly_top_up_option_2_unlimited_transactions_monthly_fee",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("totalcare_transaction_fees_option_2")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.totalcare_transaction_fees_option_2,
                expression: "printer.totalcare_transaction_fees_option_2"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value: _vm.printer.totalcare_transaction_fees_option_2
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "totalcare_transaction_fees_option_2",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("monthly_top_up_option_3")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.monthly_top_up_option_3,
                expression: "printer.monthly_top_up_option_3"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.monthly_top_up_option_3 },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "monthly_top_up_option_3",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("monthly_top_up_option_3_transaction_fee")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.monthly_top_up_option_3_transaction_fee,
                expression: "printer.monthly_top_up_option_3_transaction_fee"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value: _vm.printer.monthly_top_up_option_3_transaction_fee
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "monthly_top_up_option_3_transaction_fee",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [
            _vm._v("monthly_top_up_option_3_unlimited_transactions_monthly_fee")
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value:
                  _vm.printer
                    .monthly_top_up_option_3_unlimited_transactions_monthly_fee,
                expression:
                  "printer.monthly_top_up_option_3_unlimited_transactions_monthly_fee"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value:
                _vm.printer
                  .monthly_top_up_option_3_unlimited_transactions_monthly_fee
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "monthly_top_up_option_3_unlimited_transactions_monthly_fee",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("totalcare_transaction_fees_option_3")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.totalcare_transaction_fees_option_3,
                expression: "printer.totalcare_transaction_fees_option_3"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value: _vm.printer.totalcare_transaction_fees_option_3
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "totalcare_transaction_fees_option_3",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("monthly_top_up_option_4")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.monthly_top_up_option_4,
                expression: "printer.monthly_top_up_option_4"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.monthly_top_up_option_4 },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "monthly_top_up_option_4",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("monthly_top_up_option_4_transaction_fee")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.monthly_top_up_option_4_transaction_fee,
                expression: "printer.monthly_top_up_option_4_transaction_fee"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value: _vm.printer.monthly_top_up_option_4_transaction_fee
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "monthly_top_up_option_4_transaction_fee",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [
            _vm._v("monthly_top_up_option_4_unlimited_transactions_monthly_fee")
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value:
                  _vm.printer
                    .monthly_top_up_option_4_unlimited_transactions_monthly_fee,
                expression:
                  "printer.monthly_top_up_option_4_unlimited_transactions_monthly_fee"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value:
                _vm.printer
                  .monthly_top_up_option_4_unlimited_transactions_monthly_fee
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "monthly_top_up_option_4_unlimited_transactions_monthly_fee",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("totalcare_transaction_fees_option_4")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.totalcare_transaction_fees_option_4,
                expression: "printer.totalcare_transaction_fees_option_4"
              }
            ],
            attrs: { type: "text" },
            domProps: {
              value: _vm.printer.totalcare_transaction_fees_option_4
            },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "totalcare_transaction_fees_option_4",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("tme_ink_yield")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.tme_ink_yield,
                expression: "printer.tme_ink_yield"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.tme_ink_yield },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "tme_ink_yield", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("tme_ink_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.tme_ink_cost,
                expression: "printer.tme_ink_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.tme_ink_cost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "tme_ink_cost", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("tme_ink_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.tme_ink_sell_price,
                expression: "printer.tme_ink_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.tme_ink_sell_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "tme_ink_sell_price", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("tme_delivery_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.tme_delivery_cost,
                expression: "printer.tme_delivery_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.tme_delivery_cost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "tme_delivery_cost", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("tme_cost_per_impression")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.tme_cost_per_impression,
                expression: "printer.tme_cost_per_impression"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.tme_cost_per_impression },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "tme_cost_per_impression",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("tme_label_pack_size")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.tme_label_pack_size,
                expression: "printer.tme_label_pack_size"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.tme_label_pack_size },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "tme_label_pack_size",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("tme_label_pack_cost")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.tme_label_pack_cost,
                expression: "printer.tme_label_pack_cost"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.tme_label_pack_cost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "tme_label_pack_cost",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("tme_label_pack_sell_price")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.tme_label_pack_sell_price,
                expression: "printer.tme_label_pack_sell_price"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.tme_label_pack_sell_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.printer,
                  "tme_label_pack_sell_price",
                  $event.target.value
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("span", [_vm._v("tme_cost_per_label")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.printer.tme_cost_per_label,
                expression: "printer.tme_cost_per_label"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.printer.tme_cost_per_label },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.printer, "tme_cost_per_label", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "button-wrapper bottom" }, [
        _c(
          "div",
          {
            staticClass: "button",
            on: {
              click: function($event) {
                return _vm.savePrinter()
              }
            }
          },
          [_vm._v("Save")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4899b1d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4899b1d4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Printers/Edit.vue
// module id = null
// module chunks = 